





import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class JdiPlaceholder extends Vue {
    @Prop({default: '200px'}) width!: string;
    @Prop({default: '200px'}) height!: string;
}
